import { SidebarContext } from '../contexts/SidebarContext';
import { useContext } from 'react';

export function useSidebarItems() {
  return useContext(SidebarContext);
}
